import moment from "moment";
import "moment/dist/locale/ru";
import "moment/dist/locale/kk";
import momentHijri from 'moment-hijri'

export const toDate = (dateAsString) => {
  return moment(dateAsString).format("MMMM DD YYYY, hh:mm");
};

export const fromNow = (dateAsString) => {
  return moment(dateAsString).fromNow(false);
};

/**
 * Date => native format of Browser
 * @param {*} d: Date
 * @returns string
 */
export const toNativeDate = (d) => (d ? moment(d).format("YYYY-MM-DD") : "");
export const toFullDateName = (d) => (d ? moment(d).format("DD MMMM, YYYY") : "");
export const toTime = (d) => (d ? moment(d).format("hh:mm") : "");
export const toDocumentFormat = (d) => (d ? moment(d).format("DD.MM.YYYY") : "");
export const toDocumentFormatWithTime = (d) => (d ? moment(d).format("DD.MM.YYYY hh:mm") : "");
export const toOnlyDate = (d) => (d ? moment(d).format("DD MMMM") : "");
export const diffInDays = (d1, d2) => moment(d1).diff(d2, 'days')


export const toLocaleDate = (dateAsString) => {
  return moment(dateAsString).format("D MMMM");
};

/**
 * 
 * @param d 
 * @param format 
 * @returns 
 */
export const toHijra = (d, lang, format = "iYYYY.iMM.iDD") => {
  console.log(`lang:`, lang);

  // momentHijri().format('iD iM,iYYYY')
  const hijraDate = momentHijri(d).format(format);
  const hijraDateArray = hijraDate.split(".");

  const hijraYear = hijraDateArray[0];
  let hijraMonth = hijraDateArray[1];
  const hijraDay = hijraDateArray[2];

  // to russian locale        
  let hijraMonths = [
    "Мухаррам",
    "Сафар",
    "Раби-уль-Авваль",
    "Раби-уль-Ахир",
    "Джумада-уль-Уля",
    "Джумада-уль-Ахира",
    "Раджаб",
    "Шаабан",
    "Рамадан",
    "Шавваль",
    "Зуль-Каада",
    "Зуль-Хиджа",
  ]

  if (lang == 'kz') {
    hijraMonths = [
      'Мұхаррам',
      'Сафар',
      "Рабиғул әууәл",
      "Рабиғул ахир",
      "Жұмада әууәл",
      "Жұмада ахир",
      "Ережеп",
      "Шағбан",
      "Рамазан",
      "Шәууәл",
      "Зұлқағда",
      "Зұлхижжа"
    ]
  }

  hijraMonth = hijraMonths[hijraMonth - 1];
  return `${hijraDay} ${hijraMonth}, ${hijraYear}`;
}

/**
 * Возвращает количество дней рамадана
 */
export function getRamadanDayCounts() {
  const hijriYear = momentHijri().iYear()
  const startOfRamazan = momentHijri(`${hijriYear}-09-01`, 'iYYYY-iMM-iDD')
  const days = startOfRamazan.iDaysInMonth()
  return days
}


export function getRamadan() {
  const hijriYear = momentHijri().iYear()
  const startOfRamazan = momentHijri(`${hijriYear}-09-01`, 'iYYYY-iMM-iDD')
  const days = startOfRamazan.iDaysInMonth()
  return days
}

export function hijriToGregorian(hijriDate) {
  return momentHijri(hijriDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
}

export function gregorianToHijri(gregorianDate) {
  return moment(gregorianDate).format('iYYYY-iMM-iDD')
}

export function getHijriDate() {
  return momentHijri().format('iYYYY-iMM-iDD')
}

export function getGregorianDate() {
  return moment().format('YYYY-MM-DD')
}


/**
 * Проверяет, находится ли текущая дата в периоде Рамадана
 * @returns {boolean} true, если текущая дата находится в периоде Рамадана, иначе false
 */
export const isRamadan = () => {
  const hijriYear = momentHijri().iYear()
  const startOfRamazan = momentHijri(`${hijriYear}-09-01`, 'iYYYY-iMM-iDD')
  const endOfRamazan = momentHijri(`${hijriYear}-10-01`, 'iYYYY-iMM-iDD')
  const now = momentHijri()
  return now.isAfter(startOfRamazan) && now.isBefore(endOfRamazan)
}

/**
 * Возвращает текущий день в Рамадане
 * @returns {number} текущий день в Рамадане
 */
export const getCurrentDayInRamazan = () => {
  if (!isRamadan()) {
    // если не в рамадане, то возвращаем null
    return null
  }
  const now = momentHijri()
  return parseInt(now.format('iDD'))
}